import { Injectable } from '@angular/core';
import { MenuNode, Helper } from '../classes';
import { LogService } from './log.service';
import { DataIoService } from './data-io.service';
import { TranslationService } from './translation.service';
import { ConfigService } from './config.service';
import { Subject } from 'rxjs';
import { ValueChangedConfirmation } from '../classes/ValueChangedConfirmation';
@Injectable({
	providedIn: 'root'
})
export class MenuService {
	_debug: boolean = false;
	debug(msg: string): void {
		if (this._debug) {
			this.debug("MenuService: " + msg);
		}
	}
	private menu: MenuNode;
	private root: MenuNode;
	public currentNode: MenuNode;
	private buttons = new Array<string>();
	private mutedButtons = new Array<string>();
	private blinkingButtons = new Array<string>();
	private template_parameters = new Array<string>();
	public templateChanged$: Subject<string>;
	public buttonsChanged: Subject<string> = new Subject<string>();
	private _timeout: null;


	constructor(private log: LogService, private config: ConfigService, private ioService: DataIoService, private translator: TranslationService) {

		this.templateChanged$ = new Subject<string>();
		this.timeouts = new Array<any>();
		this.debug("instantiating.");

		this.config.menu$.subscribe(
			(resp) => {
				this.menu = resp;
				this.debug("Loading menu.");
				this.loadMenu();
			}
		);

		this.ioService.onElementFocused().subscribe(
			(element) => {
				this.onElementFocused(element);

			},
			(error) => {
				this.debug("Error handling focused element: " + JSON.stringify(error));
			}
		)
	}


	onElementFocused(element: MenuNode) {

		if (element === null || element === undefined) {
			this.enableAllButtons();
			this.setHelpAvailable(false);
		}
		let helpElement = this.findItem('help');
		if (helpElement) {
			helpElement.text = [element.getHelp()];
		}
		let currentBlockingStates = this.ioService.deviceInfo().getBlockingStates();
		if (element.getType() == 'menuentry' && !element.hasChild() && !element.hasTarget()) {
			this.debug("Disabling confirm-button for " + element.getTitle());
			this.disableButton('confirm');
		} else {
			this.enableAllButtons();
		}
		this.setHelpAvailable(element.hasHelp());
	}
	timeouts: Array<any>;
	clearTimeouts() {
		for (let id of this.timeouts) {
			clearTimeout(id);
		}
		this.timeouts.length = 0;

	}

	_helpAvailable: boolean = false;

	setHelpAvailable(b: boolean): void {
		this._helpAvailable = b;
	}

	helpAvailable(): boolean {
		return this._helpAvailable;
	}

	reset() {

		this.menu = this.root;
		this.loadMenu();

	}
	showHelp() {
		let element = this.findItem('help');
		this.goto(element);
	}
	hierarchyUp(skipHistory?: boolean, confirmation?: ValueChangedConfirmation): boolean {
		this.debug("HierarchyUp");
		let parent = this.currentNode.getParent();
		if (parent == null) {
			return false;
		}
		while (parent.getType() == 'menuentry') {
			parent = parent.getParent();
		}
		if (parent.getIdentifier() == "root") {
			this.enterMenu(this.root.findRecursive("dashboard"), false, confirmation);
			return;
		}
		if (skipHistory === true) {
			this.ioService.historyPop();
		}
		this.enterMenu(parent, false, confirmation);
		return true;
	}


	isInBlockingState() {
		return (this.ioService.deviceInfo() && this.ioService.deviceInfo().isInBlockingMode());

	}
	historyBack(confirmation?: ValueChangedConfirmation): boolean {
		this.debug("historyBack");

		if (this.ioService.historyLength() > 0) {
			let lastElement = this.ioService.historyPop();
			if (!lastElement) {
				return false;
			}
			this.debug("Going back to last element: " + lastElement.getTitle());
			this.enterMenu(lastElement, true, confirmation);
			return true;
		}
		return false;
	}

	updateHistory() {
		if (!this.currentNode) {
			return;
		}

		let identifier = this.currentNode.getIdentifier();

		if (this.currentNode && identifier != "root" && identifier) {
			if (this.ioService.getHistoryItemByIndex(this.ioService.historyLength() - 1) != this.currentNode) {
				if (
					['waterpressure', 'menu'].includes(this.currentNode.getTemplate()) ||
					(
						identifier !== undefined &&
						identifier.startsWith('absenk-temperature-') ||
						identifier.startsWith('wizard')
					)
				) {
					console.log("Adding to history: " + this.currentNode.getIdentifier());
					this.ioService.historyPush(this.currentNode);
				} else {
					console.log("Not adding to history: " + this.currentNode.getIdentifier());
				}
			} else {
				console.log("Not adding to history because it is already the last element.");
			}
		}
	}
	enterMenu(_node?: MenuNode, _omitHistoryUpdate?: boolean, confirmation?: ValueChangedConfirmation) {
		
		let omitHistoryUpdate = _omitHistoryUpdate;
		let node: MenuNode = _node;
		let previousNode = this.getCurrentNode();
		let nextNode = _node;

		this.debug("ENTER MENU." + node?.getIdentifier());
		
		let nextName = nextNode?.getIdentifier();
		let previousName = previousNode?.getIdentifier();
		//console.log(`next: ${nextName} previous: ${previousName}`)
		
		this.enableAllButtons();
		this.setHelpAvailable(false);
		if (node.getTemplate() == 'dashboard' && this.ioService.deviceInfo().getRawValue('wizard_help_shown') == "false") {
			this.ioService.deviceInfo().setValue('wizard_help_shown', 'true');
			let target = this.findItem('wizard_help');
			if (target) {
				target.setTarget('goto:dashboard');
				this.goto(target);
				return;
			} else {
				this.debug("Target is null.");
			}
		}

		if (!node.isDescendantOf('installationsroutine') && !node.isDescendantOf('2kia')) {
			if (confirmation != null && confirmation != undefined && confirmation.valueChanged()) {

				let splash = confirmation.createSplashNode();

				if (splash) {
					this.enterMenu(splash, true);
					return;
				} else {

				}
			}
		} else {
			// if node is installationroutine-node
			if (!node.isEnabled()) {
				this.debug("Skipping " + node.getTitle() + "/" + node.getIdentifier());
				let nextNode = node.getTargetNode();
				if (nextNode) {
					this.enterMenu(nextNode);
					return;
				} else {
					this.debug("Cant skip: no target");
				}
			}
		}
		// achtung... das hier klappt nur weil die confirmations dazwischenliegen.
		if (node == this.currentNode) {
			return;
		}

		/*
		if(this.isInBlockingState() && node.getIdentifier() == "dashboard") {
			this.debug("overriding due to blocked state");
			node = this.findItem('dashboard');
			omitHistoryUpdate=true;
		}
		*/

		if (omitHistoryUpdate !== true) {
			this.updateHistory();
		}

		this.clearTimeouts();
		if (node === undefined || node === null) {
			this.debug("cannot dive into node. null or undefined");
			return;
		}
		let lastNode = this.currentNode;
		this.ioService.infoTextAvailable(node);
		this.debug("entering menu: " + node.getName());
		this.currentNode = node;
		this.buttons = this.currentNode.getButtons();

		this.mutedButtons = this.currentNode.getMutedButtons();
		this.blinkingButtons = this.currentNode.getBlinkingButtons();

		this.template_parameters = this.currentNode.getTemplateParameters();
		this.templateChanged$.next(this.currentNode.getScreenTemplate());
		this.debug("Reinit-Template.");
		this.reloadTemplate(lastNode);

		this.startTimeout(node);
	}
	reloadTemplate(lastNode?: MenuNode) {
		//this.debug("reloading template.");
		if (lastNode === null || lastNode === undefined) {
			
			this.ioService.inputs.reinitTemplate();
			return;
		}
		let currentTemplate = this.currentNode.getTemplate();
		let lastTemplate = lastNode.getTemplate();
		if (currentTemplate == "control-showcase") {
			this.ioService.inputs.reinitTemplate();
			return;
		}
		//this.debug("Transition from "+lastTemplate+ " to " + currentTemplate + "("+this.currentNode.getIdentifier()+")");

		if (currentTemplate == 'help') {
			return this.ioService.inputs.downTemplate();
		}
		/*
		this.debug("From: ");
		lastNode.printAncestorTree();
		this.debug("To: ");
		this.currentNode.printAncestorTree();
		*/
		if (this.currentNode.isDescendantOf('anchor_fachhandwerker') && lastNode.isDescendantOf('anchor_fachhandwerker')) {

			if (lastNode.getTemplate() == 'loadinganimation') {
				return this.ioService.inputs.reinitTemplate();
			}
			if (lastNode.getIdentifier() === '2kiafinish') {
				return this.ioService.inputs.downTemplate();
			}
			if (this.currentNode.getLevel() < lastNode.getLevel()) {
				//this.debug("we are here: up");
				return this.ioService.inputs.upTemplate();
			}
			if (this.currentNode.getLevel() > lastNode.getLevel()) {
				//this.debug("we are here: down");
				return this.ioService.inputs.downTemplate();
			}
		} else {
			//this.debug("one of the elements is not a descendant of anchor_fachhandwerker");
		}
		if (this.currentNode.isDescendantOf('installationsroutine') || lastNode.isDescendantOf('installationsroutine') || this.currentNode.isDescendantOf('2kia') || lastNode.isDescendantOf('2kia')) {
			if (this.currentNode.hasParent() && this.currentNode.getParent() == lastNode.getParent()) {
				let currentIdx = this.currentNode.getIndexOnParent();
				let lastIdx = lastNode.getIndexOnParent();

				if (currentIdx > lastIdx) {
					return this.ioService.inputs.downTemplate();
				}
				if (lastIdx > currentIdx) {
					return this.ioService.inputs.upTemplate();
				}

			}
		}
		switch (lastTemplate) {
			case 'help': {
				return this.ioService.inputs.upTemplate();
			}
			case 'dashboard': {
				if (this.currentNode.getIdentifier() == 'mainmenu') {
					return this.ioService.inputs.downTemplate();
				}
				if (currentTemplate == 'settingsvalue') {
					return this.ioService.inputs.reinitTemplate();
				}
				if (this.currentNode.getIdentifier().startsWith("benutzerhandbuch")) {
					return this.ioService.inputs.downTemplate();
				}
				this.debug("Unhandled after dashboard:" + currentTemplate);
			}
			case 'splash': {
				if (currentTemplate == 'dashboard') {
					this.ioService.inputs.reinitTemplate();
				}
				if (currentTemplate == 'menu') {
					return this.ioService.inputs.upTemplate();
				}
				this.debug("Unhandled after splash:" + currentTemplate);
			}
			case 'menu': {
				switch (currentTemplate) {
					case 'menu': {

						if (this.currentNode.getLevel() > lastNode.getLevel()) {
							return this.ioService.inputs.downTemplate();
						}
						if (this.currentNode.getLevel() < lastNode.getLevel()) {
							return this.ioService.inputs.upTemplate();
						}
						if (this.currentNode.getLevel() == lastNode.getLevel()) {
							if (this.currentNode.hasParent() && this.currentNode.getParent() == lastNode.getParent()) {

								let currentIdx = this.currentNode.getIndexOnParent();
								let lastIdx = lastNode.getIndexOnParent();
								if (currentIdx > lastIdx) {
									return this.ioService.inputs.downTemplate();
								}
								if (lastIdx > currentIdx) {
									return this.ioService.inputs.upTemplate();
								}

							}
						}
					}
					case 'help':
					case 'list':
					case 'settingsvalue':
					case 'menu-showcase':
					case 'control-showcase': {
						return this.ioService.inputs.downTemplate();
					}
				}
			}
			case 'list': {
				switch (currentTemplate) {
					case 'menu': {
						return this.ioService.inputs.upTemplate();
					}
				}
			}
			case 'menu-showcase':
			case 'control-showcase': {
				let currentIdx = this.currentNode.getIndexOnParent();
				let lastIdx = lastNode.getIndexOnParent();
				switch (currentTemplate) {
					case 'menu-showcase':
					case 'control-showcase': {
						if (currentIdx > lastIdx) {
							return this.ioService.inputs.downTemplate();
						}
						if (currentIdx < lastIdx) {
							return this.ioService.inputs.upTemplate();
						}
					}
				}
			}
			case 'timeset':
			case 'settingsvalue': {
				if (this.currentNode.getIdentifier() == 'fachhandwerkerebene' && lastNode.getIdentifier() == 'fachhandwerker-code') {
					return this.ioService.inputs.downTemplate();
				}
				if (currentTemplate == "menu") {
					return this.ioService.inputs.upTemplate();
				}
			}
			case '': {
				if (currentTemplate == 'dashboard') {
					return this.ioService.inputs.reinitTemplate();
				}

			}
		}

		if (lastNode.hasChild(this.currentNode)) {
			return this.ioService.inputs.downTemplate();
		}
		if (this.currentNode.hasChild(lastNode)) {
			return this.ioService.inputs.upTemplate();
		}


		this.ioService.inputs.reinitTemplate();
	}
	startTimeout(node: MenuNode) {

		if (typeof node.timeout == "number" && node.timeout >= 0) {
			this.debug("setting timeout for " + node.getName());
			let to = setTimeout(() => {
				this.evaluateTimeoutAction(node);
			}, 1000 * node.timeout);
			this.timeouts.push(to);
		} else {

			this.debug("not setting timeout (" + node.timeout + ") for " + node.getName());
		}
	}
	resetTimeout() {
		this.clearTimeouts();
		this.startTimeout(this.currentNode);
	}
	evaluateTimeoutAction(node: MenuNode) {
		this.debug("Evaluating timeout-action for " + node.getIdentifier() + "/" + node.getName());
		this.clearTimeouts();
		let action = node.timeout_action;
		let target = node.timeout_action_target;
		let index = node.timeout_action_target_index;
		this.debug("Evaluating timeout-action for node " + this.currentNode.getName());
		if (this.currentNode.getIdentifier() == 'root') {
			if (this.config.config.showInstallation()) {
				this.debug("showing installation.");
				this.enterMenu(node.getChildByIndex(0));
			} else {
				this.debug("not showing installation.");
				this.enterMenu(node.getTimeoutTarget());
			}
			return;
		}
		let targetNode = node.getTimeoutTarget();
		if (!targetNode) {
			this.debug("Error: Target node was empty for " + node.getIdentifier() + " (" + node.getTemplate() + ")");
		} else {
			this.enterMenu(targetNode);
		}
	}
	loadMenu(): void {
		this.root = this.menu;
		this.enterMenu(this.menu, false);
	}

	hasParameter(param): boolean {
		return (this.currentNode.hasParameter(param));
	}
	enableAllButtons() {
		this.buttonsDisabledByView.length = 0;
		this.mutedButtons.length = 0;

	}
	disableButton(btn: string) {

		this.buttonsDisabledByView.push(btn);
		this.buttonsChanged.next('');
	}
	unblockAllButtons() {
		console.log("unblocking all buttons");

		this.buttonsDisabledByView.length = 0;
		this.buttonsChanged.next('');
	}
	buttonsDisabledByView = new Array<string>();


	scrollbarNeededByHelpWidget: boolean = false;
	isScrollbarNeededByHelpWidget(): boolean {
		return this.scrollbarNeededByHelpWidget;
	}
	setScrollbarNeededByHelpWidget(b: boolean) {
		this.scrollbarNeededByHelpWidget = b;
	}
	isDisabledByView(btn: string) {
		return this.buttonsDisabledByView.includes(btn);
	}
	buttonEnabled(btn: string): boolean {
		if (this.currentNode === undefined) {
			return false;
		}
		if (this.buttonsDisabledByView.includes(btn)) {
			return false;
		}

		switch (btn) {
			case 'menu': {
				if (this.currentNode.getIdentifier() == "idle") {
					return true;
				}
			}
			case 'up':
			case 'down':
			case 'slider':
			case 'question': {
				let blockingStates = this.ioService.deviceInfo().getBlockingStates();
				if (blockingStates.length > 0 && (blockingStates.includes('system_off') || blockingStates.includes('absence'))) {
					return false;
				}
			}
		}
		if (btn == "slider" && this.currentNode.getIdentifier() == 'help' && this.isScrollbarNeededByHelpWidget()) {
			return true;
		}
		if (btn == "slider" && this.currentNode.getTemplate() == 'list' && this.isScrollbarNeededByHelpWidget()) {
			return true;
		}
		return (this.buttons.indexOf(btn) != -1 || this.buttons.indexOf('all') != -1 || this.currentNode.hasButton(btn));
	}
	buttonMuted(btn: string): boolean {
		return (this.mutedButtons.includes(btn) || this.mutedButtons.includes('all'));
	}
	blinkButton(btn) {
		this.blinkingButtons.push(btn);
	}
	unblinkButton(btn) {
		let idx = this.blinkingButtons.indexOf(btn);
		if (idx >= 0) {
			this.blinkingButtons.splice(idx, 1);
		}
	}
	buttonBlinking(btn: string): boolean {
		return (this.blinkingButtons.includes(btn) || this.blinkingButtons.includes('all'));
	}
	getText(idx: number): string {
		return this.currentNode.getText(idx);
	}

	selectPreviousMenuItem(node?: MenuNode): void {
		if (this.hasPreviousMenuItem()) {
			let currentIndex = this.currentNode.getParent().getIndexForChild(this.currentNode);
			let previousNode = this.currentNode.getParent().getChildByIndex(currentIndex - 1);
			this.enterMenu(previousNode, false);
		}
	}
	hasPreviousMenuItem(node?: MenuNode): boolean {
		if (this.currentNode.getParent() == null) {
			return false;
		}

		let currentIndex = this.currentNode.getParent().getIndexForChild(this.currentNode);
		return currentIndex > 0;
	}

	selectNextMenuItem(node?: MenuNode): void {
		if (this.hasNextMenuItem()) {
			let currentIndex = this.currentNode.getParent().getIndexForChild(this.currentNode);
			let nextNode = this.currentNode.getParent().getChildByIndex(currentIndex + 1);
			this.enterMenu(nextNode, false);
		} else {
			this.debug("cannot go to next item: there is none.");
		}
	}
	hasNextMenuItem(node?: MenuNode): boolean {
		if (this.currentNode.getParent() == null) {
			return false;
		}
		let currentIndex = this.currentNode.getParent().getIndexForChild(this.currentNode);
		return (currentIndex < this.currentNode.getParent().getChilds().length - 1);
	}
	getCurrentNode(): MenuNode {
		return this.currentNode;
	}
	parentHasNext(): boolean {
		if (!(this.currentNode.getParent()) || !(this.currentNode.getParent().getParent())) {
			return false;
		}
		let currentIndex = this.currentNode.getParent().getParent().getIndexForChild(this.currentNode.getParent());
		return (currentIndex < this.currentNode.getParent().getParent().getChilds().length - 1);
	}
	selectParentNext() {
		if (this.parentHasNext()) {
			let currentIndex = this.currentNode.getParent().getParent().getIndexForChild(this.currentNode.getParent());
			let nextNode = this.currentNode.getParent().getParent().getChildByIndex(currentIndex + 1);
			this.enterMenu(nextNode);
		} else {
			this.debug("cannot go to next item: there is none.");
		}
	}


	goto(_target: string | MenuNode, confirmation?: ValueChangedConfirmation) {
		
		let target = _target;
		if (typeof target == 'string' && target.startsWith('goto:')) {
			//console.log(`going to ${target}`);
			target = target.replace('goto:', '');
		}
		if (confirmation) {
			this.debug("Have confirmation!: " + confirmation);
		}
		if (target instanceof MenuNode) {
			//console.log("Going to " + target.getIdentifier());
			this.enterMenu(target, false, confirmation);
			return;
		} else {
			//console.log("Going to " + target);
			if (target === null) {
				return;
			}


			if (target.startsWith('history:')) {
				let parts = Helper.split(target, ':');
				if (parts[0] == "history") {
					if (parts[1] == "back") {
						if (parts.length == 3) {
							let backSteps = parseInt(parts[2]);
							for (; backSteps > 0; backSteps--) {
								this.historyBack(confirmation);
							}
						} else {
							this.historyBack(confirmation);
						}
					}
				}
			}

			//console.debug("Going to " + target);
			let targetElement = this.findItem(target, this.root);

			if (targetElement != null) {

				this.enterMenu(targetElement, false, confirmation);
			} else {
				//console.debug("Target not found: " + target);
			}
		}
	}
	// find element with id recursive starting from element.
	findItem(id: any, element?: MenuNode): MenuNode {
		if (!element) {
			element = this.root;
		}
		if (element.getIdentifier() == id) {
			this.debug("Found element with id " + id);
			return element;
		}

		for (let child of element.getChilds()) {
			if (child.getIdentifier() == id) {
				//console.debug("Found childelement with id " + id);
				return child;
			}
			if (child.getChilds().length > 0) {
				let result = this.findItem(id, child);
				if (result != null && result.getIdentifier()) {
					return result;
				}
			}
		}

		let search = this.root.findRecursive(id);
		if (search !== undefined) {
			//console.debug("recursive search for " + id + " had no result.");
		}

		return search;
	}

	resetMenuPositions() {
		this.root.run(
			function (node: MenuNode) {
				if (node.selected == 'true') {
					node.selected = '';
				}
				node.close();
			}, -1);
	}
}
